/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const AlertIcon = ({ color = 'var(--highlight)', ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0007 19.1667C4.9379 19.1667 0.833984 15.0628 0.833984 10C0.833984 4.93726 4.9379 0.833344 10.0007 0.833344C15.0634 0.833344 19.1673 4.93726 19.1673 10C19.1673 15.0628 15.0634 19.1667 10.0007 19.1667ZM10.0007 17.3333C11.9456 17.3333 13.8108 16.5607 15.1861 15.1855C16.5614 13.8102 17.334 11.9449 17.334 10C17.334 8.05509 16.5614 6.18983 15.1861 4.81456C13.8108 3.43929 11.9456 2.66668 10.0007 2.66668C8.05573 2.66668 6.19047 3.43929 4.8152 4.81456C3.43993 6.18983 2.66732 8.05509 2.66732 10C2.66732 11.9449 3.43993 13.8102 4.8152 15.1855C6.19047 16.5607 8.05573 17.3333 10.0007 17.3333ZM9.08398 12.75H10.9173V14.5833H9.08398V12.75ZM9.08398 5.41668H10.9173V10.9167H9.08398V5.41668Z"
      fill={color}
    />
  </svg>
);

export default AlertIcon;
